export default __webpack_public_path__ + "static/media/tearout.e283e4a7.png";